<template>
  <div class="">
    <card id="ler_step4_detailInfo" tabindex="0" class="mt-15">
      <div slot="header">
        <h3 class="card-title">상세 정보</h3>
      </div>
      <div class="row m-row">
        <!-- 공급면적 -->
        <div class="fl col-lg-6 px-0 mb-10">
          <label class="fl col-3 col-form-label px-0">공급면적</label>
          <div class="fl col-9 mb-10 pl-0">
            <el-input
              class="fl"
              v-model="finalProvArea"
              disabled
              style="width: 42%"
            >
              <template slot="append">m²</template>
            </el-input>
            <i
              class="fl fas fa-sync-alt AreaIcon m-auto"
              style="width: 16%; text-align: center"
            ></i>
            <el-input
              class="fr"
              v-model="supplyAreaP"
              disabled
              style="width: 42%"
            >
              <template slot="append">평</template>
            </el-input>
          </div>
        </div>

        <!--전용면적 -->
        <div class="fl col-lg-6 px-0 mb-10">
          <label class="fl col-3 col-form-label px-0">전용면적</label>

          <div class="fl col-9 mb-10 pl-0">
            <el-input
              style="width: 42%"
              class="fl"
              v-model="finalUseArea"
              disabled
            >
              <template slot="append">m²</template>
            </el-input>
            <i
              class="fl fas fa-sync-alt AreaIcon"
              style="width: 16%; text-align: center"
            ></i>
            <el-input class="fr" style="width: 42%" v-model="useAreaP" disabled>
              <template slot="append">평</template>
            </el-input>
          </div>
        </div>

        <!--해당 층/ 총 층 -->
        <div class="fl col-lg-6 px-0 mb-10">
          <label class="fl col-3 col-form-label px-0">해당 층/총 층</label>
          <div class="fl col-9 pl-0 mb-10">
            <el-input
              class="fl"
              v-model="modifiedFlr"
              disabled
              style="width: 42%"
            >
              <template slot="append">층</template>
            </el-input>

            <font class="fl" size="5px" style="width: 16%; text-align: center"
              >/</font
            >
            <el-input
              class="fr"
              style="width: 42%"
              v-model="certification.grndFlrCnt"
              disabled
            >
              <template slot="append">층</template>
            </el-input>
          </div>
        </div>

        <!-- 방 수 -->
        <div class="fl col-lg-6 px-0 mb-10">
          <label class="fl col-3 col-form-label px-0">방 수</label>
          <div class="fl col-5 pl-0 jipvio-bg-white">
            <ValidationProvider
              vid="TNORoomsVal"
              rules="required"
              v-slot="{ failed }"
            >
              <fg-input :error="failed ? '필수 입력 항목입니다!' : null">
                <el-select
                  ref="TNORoomsSelectRef"
                  v-model="TNORooms"
                  placeholder="방 수"
                  @change="TNORoomsDirectWrite()"
                >
                  <el-option label="1개" value="1"></el-option>
                  <el-option label="2개" value="2"></el-option>
                  <el-option label="3개" value="3"></el-option>
                  <el-option label="4개" value="4"></el-option>
                  <el-option label="직접입력" value="null"></el-option>
                </el-select>
              </fg-input>
            </ValidationProvider>
          </div>
          <div class="fr pr-15 TNORooms_wdth" v-if="TNORoomsDirect">
            <el-input v-model="TNORooms"
              ><template slot="append">개</template></el-input
            >
          </div>
        </div>

        <!--욕실 수 -->

        <div class="fl col-lg-6 px-0">
          <label class="fl col-3 col-form-label px-0">욕실 수</label>
          <div class="fl col-5 pl-0 mb-10 jipvio-bg-white">
            <ValidationProvider
              vid="TNOBathRoomsVal"
              rules="required"
              v-slot="{ failed }"
            >
              <fg-input :error="failed ? '필수 입력 항목입니다!' : null">
                <el-select
                  ref="TNOBathRoomsSelectRef"
                  v-model="TNOBathRooms"
                  placeholder="욕실 수"
                  @change="TNOBathRoomsDirectWrite()"
                >
                  <el-option label="1개" value="1"></el-option>
                  <el-option label="2개" value="2"></el-option>
                  <el-option label="3개" value="3"></el-option>
                  <el-option label="4개" value="4"></el-option>
                  <el-option label="직접입력" value="null"></el-option>
                </el-select>
              </fg-input>
            </ValidationProvider>
          </div>
          <div class="fr pr-15 TNORooms_wdth" v-if="TNOBathRoomsDirect">
            <el-input v-model="TNOBathRooms"
              ><template slot="append">개</template></el-input
            >
          </div>
        </div>

        <!--승강기-->
        <div class="fl col-lg-6 px-0">
          <label class="fl col-3 col-form-label px-0">승강기</label>

          <div class="fl col-9 pl-0">
            <ValidationProvider
              vid="eleYnVal"
              rules="required"
              v-slot="{ failed }"
            >
              <fg-input :error="failed ? '필수 입력 항목입니다!' : null">
                <el-radio-group v-model="eleYn">
                  <el-radio class="mr-0" ref="eleYnButtonRef" label="1" border
                    >있음</el-radio
                  >
                  <el-radio class="m-ml-0" label="0" border>없음</el-radio>
                </el-radio-group>
              </fg-input>
            </ValidationProvider>
          </div>
        </div>

        <!-- 난방방식 -->
        <div class="fl col-lg-6 px-0 mb-10">
          <label class="fl col-3 col-form-label px-0">난방방식</label>
          <div class="fl col-9 pl-0 jipvio-bg-white">
            <ValidationProvider
              vid="heatingTypeVal"
              rules="required"
              v-slot="{ failed }"
            >
              <fg-input :error="failed ? '필수 입력 항목입니다!' : null">
                <el-select
                  ref="heatingTypeSelectRef"
                  v-model="heatingType"
                  placeholder="난방방식"
                >
                  <el-option
                    v-for="opt in selects.HTT"
                    :key="opt.value"
                    :label="opt.label"
                    :value="opt.value"
                  ></el-option>
                </el-select>
              </fg-input>
            </ValidationProvider>
          </div>
        </div>

        <!--난방연료 -->
        <div class="fl col-lg-6 px-0 mb-10">
          <label class="fl col-3 col-form-label px-0">난방연료</label>
          <div class="fl col-9 pl-0 jipvio-bg-white">
            <ValidationProvider
              vid="heatingFuelVal"
              rules="required"
              v-slot="{ failed }"
            >
              <fg-input :error="failed ? '필수 입력 항목입니다!' : null">
                <el-select
                  ref="heatingFuelSelectRef"
                  v-model="heatingFuel"
                  placeholder="난방연료"
                >
                  <el-option
                    v-for="opt in selects.HFT"
                    :key="opt.value"
                    :label="opt.label"
                    :value="opt.value"
                  ></el-option>
                </el-select>
              </fg-input>
            </ValidationProvider>
          </div>
        </div>

        <!--현관구조 -->
        <div class="fl col-lg-6 px-0 mb-10">
          <label class="fl col-3 col-form-label px-0">현관구조</label>

          <div class="fl col-9 pl-0 jipvio-bg-white">
            <ValidationProvider
              vid="entStructureVal"
              rules="required"
              v-slot="{ failed }"
            >
              <fg-input :error="failed ? '필수 입력 항목입니다!' : null">
                <el-select
                  ref="entStrSelectRef"
                  v-model="entStructure"
                  placeholder="현관구조"
                >
                  <el-option
                    v-for="opt in selects.ETT"
                    :key="opt.value"
                    :label="opt.label"
                    :value="opt.value"
                  ></el-option>
                </el-select>
              </fg-input>
            </ValidationProvider>
          </div>
        </div>

        <!--방향 -->
        <div class="fl col-lg-6 px-0 mb-10">
          <label class="fl col-sm-3 col-3 col-form-label px-0">
            방향
            <el-tooltip effect="dark" placement="top-start">
              <div slot="content">
                &lt;방향기준&gt;
                <br />주거용: 거실, 안방 등 주실 기준 <br />그 밖의 건물: 주
                출입구 기준
              </div>
              <i class="fas fa-exclamation-circle jipvio-color1"></i>
            </el-tooltip>
          </label>

          <div class="fl col-sm-4 col-4 px-0 jipvio-bg-white">
            <ValidationProvider
              vid="directionStdVal"
              rules="required"
              v-slot="{ failed }"
            >
              <fg-input :error="failed ? '필수 입력 항목입니다!' : null">
                <el-select
                  ref="directionStdSelectRef"
                  v-model="directionStd"
                  placeholder="기준"
                >
                  <el-option
                    v-for="opt in selects.DST"
                    :key="opt.value"
                    :label="opt.label"
                    :value="opt.value"
                  ></el-option>
                </el-select>
              </fg-input>
            </ValidationProvider>
          </div>
          <div class="fl col-sm-4 col-4 pr-0 jipvio-bg-white">
            <ValidationProvider
              vid="directionVal"
              rules="required"
              v-slot="{ failed }"
            >
              <fg-input :error="failed ? '필수 입력 항목입니다!' : null">
                <el-select
                  ref="directionSelectRef"
                  v-model="direction"
                  placeholder="방향"
                >
                  <el-option
                    v-for="opt in selects.DRT"
                    :key="opt.value"
                    :label="opt.label"
                    :value="opt.value"
                  ></el-option>
                </el-select>
              </fg-input>
            </ValidationProvider>
          </div>
        </div>

        <!-- 베란다/발코니 -->
        <div class="fl col-lg-6 px-0 mb-10">
          <label class="fl col-3 col-form-label pl-0">베란다/발코니</label>
          <div class="fl col-9 col-6 px-0">
            <el-checkbox
              v-model="verandaYn"
              label="베란다"
              border
              class="ml-0 mr-0"
            ></el-checkbox>
            <el-checkbox
              class="ml-0 mr-0"
              v-model="balconyYn"
              label="발코니"
              border
            ></el-checkbox>
          </div>
        </div>

        <!--주차가능대수 -->
        <div class="fl col-lg-6 px-0 mb-10">
          <label class="fl col-sm-3 col-3 col-form-label pl-0"
            >주차가능대수</label
          >

          <div class="fl col-md-3 col-sm-3 col-8 pl-0 jipvio-bg-white">
            <ValidationProvider
              vid="parkingYnVal"
              rules="required"
              v-slot="{ failed }"
            >
              <fg-input :error="failed ? '필수 입력 항목입니다!' : null">
                <el-select
                  ref="parkingYnSelectRef"
                  v-model="parkingYn"
                  placeholder="주차"
                >
                  <el-option label="가능" value="1"></el-option>
                  <el-option label="불가능" value="0"></el-option>
                </el-select>
              </fg-input>
            </ValidationProvider>
          </div>
          <div v-if="Number(parkingYn) === 1" class="col-sm-6 row m-row px-0">
            <label class="fr col-3 pl-0 pr-10 col-form-label">가구당</label>
            <ValidationProvider
              vid="pknPerFmlyVal"
              rules="required"
              v-slot="{ failed }"
              class="fr col-9 px-0"
            >
              <fg-input
                :error="failed ? '가구 당 주차대수를 입력해주세요.' : null"
                class="fl"
              >
                <el-input v-model="PknPerFmly" type="number"
                  ><template slot="append">대</template>
                </el-input>
              </fg-input>
            </ValidationProvider>
          </div>
        </div>
        <!-- 관리비-->
        <div class="fl col-lg-6 px-0 mb-10 row m-row">
          <label class="fl col-lg-3 col-3 col-form-label px-0">관리비</label>
          <div class="fl maintenanceFee col-xl-4 col-md-8 col-sm-7 col-7 px-0">
            <ValidationProvider
              vid="maintenanceFeeVal"
              rules="required"
              v-slot="{ failed }"
            >
              <fg-input
                type="number"
                class="fl px-0"
                :error="failed ? '필수 입력 항목입니다!' : null"
                v-model="maintenanceFee"
                label="만원"
                style="width: 100%;"
              ></fg-input>
            </ValidationProvider>
          </div>
          <div class="fl col-xl-5 col-12 maintenanceFee px-0 row m-row m-0">
            <label
              class="col-xl-4 col-3 col-form-label pl-0"
              id="maintenancefeelistlabel"
              >관리비항목</label
            >
            <el-select
              class="fl col-xl-8 col-9 pl-0 ft-18"
              ref="maintenListSelectRef"
              v-model="maintenList"
              placeholder="관리비항목"
              multiple
              style="width:100%;"
            >
              <el-option
                v-for="opt in selects.MTN"
                :key="opt.value"
                :label="opt.label"
                :value="opt.value"
              ></el-option>
            </el-select>
          </div>
        </div>

        <!--사용료 -->
        <div class="fl col-lg-6 px-0 mb-10 jipvio-bg-white">
          <label class="fl col-3 col-form-label px-0">사용료</label>
          <div class="fl col-9 pl-0">
            <ValidationProvider
              vid="useFeeYnVal"
              rules="required"
              v-slot="{ failed }"
              class="fl mr-10"
            >
              <fg-input :error="failed ? '필수 입력 항목입니다!' : null">
                <el-radio-group v-model="useFeeYn">
                  <el-radio
                    class="ml-0 mr-0"
                    ref="useFeeYnButtonRef"
                    label="1"
                    border
                    >있음</el-radio
                  >
                  <el-radio
                    class="m-ml-0"
                    label="0"
                    border
                    @change="useFeeList = []"
                    >없음</el-radio
                  >
                </el-radio-group>
              </fg-input>
            </ValidationProvider>
            <!-- <el-input class="fl" style="width:60px" v-model="useFee"></el-input> -->

            <div v-if="Number(useFeeYn) === 1">
              <ValidationProvider
                vid="useFeeListSelectVal"
                rules="required"
                v-slot="{ failed }"
                class="fl col-md-7 px-0"
              >
                <fg-input :error="failed ? '필수 입력 항목입니다!' : null">
                  <el-select
                    ref="useFeeListSelectRef"
                    v-model="useFeeList"
                    placeholder="사용료항목"
                    multiple
                    class="fl ft-18"
                  >
                    <el-option
                      v-for="opt in selects.UUF"
                      :key="opt.value"
                      :label="opt.label"
                      :value="opt.value"
                    ></el-option>
                  </el-select>
                </fg-input>
              </ValidationProvider>
            </div>
          </div>
        </div>
      </div>
    </card>
  </div>
</template>

<script>
import { createNamespacedHelpers, mapGetters } from "vuex";

const { mapGetters: sessionMapGetters } = createNamespacedHelpers(
  "loginSession"
);

import {
  Card,
  Checkbox,
  Input,
  Select,
  Option,
  RadioGroup,
  Radio,
  Tooltip,
  Message
} from "element-ui";

export default {
  components: {
    Card,
    [Checkbox.name]: Checkbox,
    [Input.name]: Input,
    [Select.name]: Select,
    [Option.name]: Option,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    [Tooltip.name]: Tooltip
  },

  data() {
    return {
      TNORooms: null, //방 수
      TNORoomsDirect: false, // 방 수 직접선택 체크박스
      TNOBathRooms: null, //욕실 수
      TNOBathRoomsDirect: null, //욕실 수 직접선택 체크박스
      eleYn: null, // 승강기 여부
      heatingType: null, //난방방식
      heatingFuel: null, //난방연료
      entStructure: null, //현관구조
      directionStd: null, //방향 기준
      direction: null, //방향
      verandaYn: false, //베란다 체크박스
      balconyYn: false, // 발코니 체크박스
      parkingYn: null, // 주차가능여부
      PknPerFmly: null, // 가구당 주차가능대수
      maintenanceFee: null, //관리비
      maintenList: [], //선택된 관리비 포함항목
      useFeeYn: null, //사용료
      useFeeList: [], //사용료 포함내역

      selects: {
        ETT: [],
        HTT: [],
        HFT: [],
        MTN: [],
        DRT: [],
        UUF: [],
        DST: []
      }
    };
  },

  created() {
    this.bringData();
    this.applyCommonCode();
  },

  computed: {
    ...sessionMapGetters({
      sessionCoCodeMap: "getCoCodeMap",
      sessionPropertyInquiry: "getPropertyInquiry"
    }),

    certification() {
      return this.sessionPropertyInquiry.certification;
    },

    finalProvArea() {
      if (this.certification.partArea != 0) {
        return this.certification.partArea;
      } else {
        return this.certification.provArea;
      }
    },
    supplyAreaP() {
      return Math.round(this.finalProvArea * 0.3025);
    },
    useAreaP() {
      return Math.round(this.finalUseArea * 0.3025);
    },
    finalUseArea() {
      if (this.certification.partArea != 0) {
        return this.certification.partArea;
      } else {
        return this.certification.useArea;
      }
    },
    modifiedFlr() {
      if (
        this.certification.AddrFloor != null &&
        this.certification.AddrFloor.charAt(
          this.certification.AddrFloor.length - 1
        ) == "층"
      ) {
        return this.certification.AddrFloor.slice(0, -1);
      } else {
        return this.certification.AddrFloor;
      }
    }
  },

  methods: {
    bringData() {
      this.TNORooms = this.sessionPropertyInquiry.propertyInfo.TNORooms; //방 수
      this.TNORoomsDirect = this.sessionPropertyInquiry.propertyInfo.TNORoomsDirect; // 방 수 직접선택 체크박스
      this.TNOBathRooms = this.sessionPropertyInquiry.propertyInfo.TNOBathRooms; //욕실 수
      this.TNOBathRoomsDirect = this.sessionPropertyInquiry.propertyInfo.TNOBathRoomsDirect; //욕실 수 직접선택 체크박스
      this.eleYn = Number(
        this.sessionPropertyInquiry.propertyInfo.eleYn
      ).toString(); // 승강기 여부
      this.heatingType = this.sessionPropertyInquiry.propertyInfo.heatingType; //난방방식
      this.heatingFuel = this.sessionPropertyInquiry.propertyInfo.heatingFuel; //난방연료
      this.entStructure = this.sessionPropertyInquiry.propertyInfo.entStructure; //현관구조
      this.directionStd = this.sessionPropertyInquiry.propertyInfo.directionStd; //방향 기준
      this.direction = this.sessionPropertyInquiry.propertyInfo.direction; //방향
      this.verandaYn = this.sessionPropertyInquiry.propertyInfo.verandaYn; //베란다 체크박스
      this.balconyYn = this.sessionPropertyInquiry.propertyInfo.balconyYn; // 발코니 체크박스
      this.parkingYn = Number(
        this.sessionPropertyInquiry.propertyInfo.parkingYn
      ).toString(); // 주차가능여부
      this.PknPerFmly = Number(
        this.sessionPropertyInquiry.propertyInfo.PknPerFmly
      ); // 가구당 주차가능대수
      this.maintenanceFee = Number(
        this.sessionPropertyInquiry.propertyInfo.maintenanceFee
      ); //관리비
      this.maintenList = this.sessionPropertyInquiry.propertyInfo.maintenList; //선택된 관리비 포함항목
      this.useFeeYn = Number(
        this.sessionPropertyInquiry.propertyInfo.useFeeYn
      ).toString(); //사용료 유무
      this.useFeeList = this.sessionPropertyInquiry.propertyInfo.useFeeList; //사용료 포함내역
    },
    applyCommonCode() {
      //ETT========================================================
      this.sessionCoCodeMap.ETT.forEach((ele, dex) => {
        this.selects.ETT.push({
          value: ele.code,
          label: ele.name
        });
      });

      //HTT========================================================
      this.sessionCoCodeMap.HTT.forEach((ele, dex) => {
        this.selects.HTT.push({
          value: ele.code,
          label: ele.name
        });
      });

      //HFT========================================================
      this.sessionCoCodeMap.HFT.forEach((ele, dex) => {
        this.selects.HFT.push({
          value: ele.code,
          label: ele.name
        });
      });
      //MTN========================================================
      this.sessionCoCodeMap.MTN.forEach((ele, dex) => {
        this.selects.MTN.push({
          value: ele.code,
          label: ele.name
        });
      });

      //DRT========================================================
      this.sessionCoCodeMap.DRT.forEach((ele, dex) => {
        this.selects.DRT.push({
          value: ele.code,
          label: ele.name
        });
      });

      //UUF========================================================
      this.sessionCoCodeMap.UUF.forEach((ele, dex) => {
        this.selects.UUF.push({
          value: ele.code,
          label: ele.name
        });
      });

      //DST========================================================
      this.sessionCoCodeMap.DST.forEach((ele, dex) => {
        this.selects.DST.push({
          value: ele.code,
          label: ele.name
        });
      });
    },

    TNORoomsDirectWrite() {
      if (this.TNORooms == "null") {
        this.TNORooms = null;
        this.TNORoomsDirect = true;
      } else {
        this.TNORoomsDirect = false;
      }
    },
    TNOBathRoomsDirectWrite() {
      if (this.TNOBathRooms == "null") {
        this.TNOBathRooms = null;
        this.TNOBathRoomsDirect = true;
      } else {
        this.TNOBathRoomsDirect = false;
      }
      console.log(this.TNOBathRoomsDirect);
    },

    SendDetailData() {
      let data = {
        TNORooms: this.TNORooms,
        TNORoomsDirect: this.TNORoomsDirect,
        TNOBathRooms: this.TNOBathRooms,
        TNOBathRoomsDirect: this.TNOBathRoomsDirect,
        eleYn: this.eleYn,
        heatingType: this.heatingType,
        heatingFuel: this.heatingFuel,
        entStructure: this.entStructure,
        directionStd: this.directionStd,
        direction: this.direction,
        verandaYn: this.verandaYn,
        balconyYn: this.balconyYn,
        parkingYn: this.parkingYn,
        PknPerFmly: this.PknPerFmly,
        maintenanceFee: this.maintenanceFee,
        maintenList: this.maintenList,
        useFeeYn: this.useFeeYn,
        useFeeList: this.useFeeList
      };
      this.$emit("SendDetailData", data);
    }
  }
};
</script>

<style></style>
